import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinGeneralServiceUnit = createAsyncThunk(
    "generalServiceUnit/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/GeneralServiceUnit/getMin",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.GeneralServiceUnitID,
                        label: item.GeneralServiceUnitName,
                    })
                );
                return {data: newObj};

            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getGeneralServiceUnit = createAsyncThunk(
    "generalServiceUnit/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/GeneralServiceUnit/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertGeneralServiceUnit = createAsyncThunk(
    "generalServiceUnit/insert",
    async ({GeneralServiceUnitName, CategoryID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("GeneralServiceUnitName", GeneralServiceUnitName);
        formData.append("CategoryID", CategoryID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/GeneralServiceUnit/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateGeneralServiceUnit = createAsyncThunk(
    "generalServiceUnit/update",
    async (
        {
            KategoriGeneralServiceUnitID,
            GeneralServiceUnitName,
            GeneralServiceUnitID,
            status,
        },
        thunkAPI
    ) => {
        let formData = new FormData();
        formData.append("CategoryID", KategoriGeneralServiceUnitID);
        formData.append("GeneralServiceUnitName", GeneralServiceUnitName);
        formData.append("GeneralServiceUnitID", GeneralServiceUnitID);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/GeneralServiceUnit/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const generalServiceUnitSlice = createSlice({
    name: "generalServiceUnit",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinGeneralServiceUnit.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinGeneralServiceUnit.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinGeneralServiceUnit.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getGeneralServiceUnit.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getGeneralServiceUnit.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getGeneralServiceUnit.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertGeneralServiceUnit.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertGeneralServiceUnit.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertGeneralServiceUnit.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateGeneralServiceUnit.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateGeneralServiceUnit.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateGeneralServiceUnit.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const generalServiceUnitSelector = (state) => state.generalServiceUnit;
